export default __webpack_public_path__ + "static/media/google.db8e91f9.png";